import type { es } from "./hl/es";
export const supportLang = [
	{ code: "en", direction: "ltr" }, // Inglés
	{ code: "es", direction: "ltr" }, // Español
	{ code: "da", direction: "ltr" }, // Danés
	{ code: "de", direction: "ltr" }, // Alemán
	{ code: "fr", direction: "ltr" }, // Francés
	{ code: "it", direction: "ltr" }, // Italiano
	{ code: "pl", direction: "ltr" }, // Polaco
	{ code: "pt", direction: "ltr" }, // Portugués
	{ code: "ja", direction: "ltr" }, // Japonés
	{ code: "ko", direction: "ltr" }, // Coreano
	{ code: "ru", direction: "ltr" }, // Ruso
	{ code: "nl", direction: "ltr" }, // Neerlandés
	{ code: "hi", direction: "ltr" }, // Hindi
	{ code: "zh", direction: "ltr" }, // Chino
	{ code: "ar", direction: "rtl" }, // Árabe
	{ code: "tr", direction: "ltr" } // Turco
] as const;
export type SupportedLangs = (typeof supportLang)[number]["code"] | (string & {}); /* Trick para que acepte un string y ts de autocompletado */

export function getLang(defaultLang = "en"): SupportedLangs {
	if (localStorage.lang == "null") delete localStorage.lang;
	// Si viene el `hl` en la URL, esto tiene mas alta prioridad
	let hl = new URL(location.href).searchParams.get("hl");
	if (hl) localStorage.lang = hl.substring(0, 2);
	let lang = localStorage.lang || window.navigator.language || defaultLang;
	lang = lang.substring(0, 2);
	if (supportLang.some(l => l.code === lang)) {
		return lang;
	} else {
		return "en";
	}
}
export async function LoadAppi18n() {
	document.documentElement.lang = getLang();
	switch (getLang()) {
		case "en":
			let en = await import("./hl/en");
			replaceStringDictionary(en.en);
			break;
		case "es":
			let es = await import("./hl/es");
			replaceStringDictionary(es.es);
			break;
		case "da":
			let da = await import("./hl/da");
			replaceStringDictionary(da.da);
			break;
		case "de":
			let de = await import("./hl/de");
			replaceStringDictionary(de.de);
			break;
		case "fr":
			let fr = await import("./hl/fr");
			replaceStringDictionary(fr.fr);
			break;
		case "it":
			let it = await import("./hl/it");
			replaceStringDictionary(it.it);
			break;
		case "pl":
			let pl = await import("./hl/pl");
			replaceStringDictionary(pl.pl);
			break;
		case "pt":
			let pt = await import("./hl/pt");
			replaceStringDictionary(pt.pt);
			break;
		case "ja":
			let ja = await import("./hl/ja");
			replaceStringDictionary(ja.ja);
			break;
		case "ko":
			let ko = await import("./hl/ko");
			replaceStringDictionary(ko.ko);
			break;
		case "ru":
			let ru = await import("./hl/ru");
			replaceStringDictionary(ru.ru);
			break;
		case "nl":
			let nl = await import("./hl/nl");
			replaceStringDictionary(nl.nl);
			break;
		case "hi":
			let hi = await import("./hl/hi");
			replaceStringDictionary(hi.hi);
			break;
		case "zh":
			let zh = await import("./hl/zh");
			replaceStringDictionary(zh.zh);
			break;
		case "ar":
			let ar = await import("./hl/ar");
			replaceStringDictionary(ar.ar);
			break;
		case "tr":
			let tr = await import("./hl/tr");
			replaceStringDictionary(tr.tr);
			break;
	}
	// Se agregan rubros y tipos de educación
	replaceStringDictionary({
		rubros: {
			"-1": ["Cualquier Cargo"],
			"1": [
				"Ejecutivo de ventas",
				"Vendedor",
				"Vendedor Rutero",
				"Supervisor de Ventas",
				"Gerente de Ventas",
				"Promotor(a) de Ventas",
				"Jefe de Sucursal | Agencia",
				"Administrativo de Ventas | Soporte de Ventas",
				"Vendedor de Mostrador | Interno",
				"Jefe de Ventas",
				"Asistente de Ventas",
				"Analista de Mercadeo | Investigación de Mercados",
				"Ejecutivo de Ventas Industriales",
				"Gerente de Cuentas Claves",
				"Asistente de Mercadeo",
				"Ejecutivo de Telemarketing",
				"Impulsador de Ventas",
				"Display",
				"Ejecutivo de Ventas Técnicas",
				"Jefe de Mercadeo",
				"Mercaderista | Merchandiser",
				"Gerente de Mercadeo y Ventas",
				"Trade Marketing",
				"Gerente de Mercadeo",
				"Gerente de Sucursal"
			],
			"2": [
				"Asistente Contable ",
				"Cajero",
				"Gestor de Cobros",
				"Contador General",
				"Analista Financiero",
				"Auditor Interno",
				"Asistente de Auditoría Interna",
				"Asistente de Crédito y Cobro",
				"Jefe de Crédito y Cobro",
				"Asesor de Crédito",
				"Asistente de Planillas",
				"Jefe de Contabilidad",
				"Asistente de Auditoría Externa",
				"Asistente de Costos",
				"Asistente o Encargado de Tesorería",
				"Auditor Externo",
				"Encargado de Planillas",
				"Gerente de Contabilidad",
				"Gerente de Finanzas y Administración",
				"Asistente de Auditoría Fiscal",
				"Jefe de Finanzas",
				"Jefe de Presupuestos",
				"Jefe de Tesorería",
				"Gerente de Créditos | Cobros",
				"Jefe de Auditoría Externa"
			],
			"3": [
				"Asistente de Mantenimiento",
				"Mecánico Automotriz",
				"Supervisor de Mantenimiento",
				"Mecánico",
				"Electricista",
				"Electromecánico",
				"Jefe de Mantenimiento | Industrial",
				"Técnico en Electrónica",
				"Técnico en Refrigeración",
				"Jefe de Taller Mecánico Eléctrico",
				"Soldador",
				"Técnico Especializado",
				"Operador Maquinaria Pesada",
				"Albañil",
				"Jardinero",
				"Gerente de Mantenimiento",
				"Técnico Chapistero",
				"Aseador de Equipo",
				"Carpintero",
				"Gerente de Talleres",
				"Pintor"
			],
			"4": [
				"Analista | Programador",
				"Programador iOS",
				"Analista de Sistemas",
				"Administrador de Base de Datos",
				"Programador Backend",
				"Programador Web",
				"Programador Full-Stack",
				"Programador Android",
				"Administrador de Redes",
				"Auditor de Sistemas",
				"Diseñador Web",
				"Operador de Sistemas",
				"Jefe de Soporte Técnico",
				"Director de Informática | Sistemas",
				"Web Master"
			],
			"5": [
				"Ingeniero en Sistemas",
				"Ingeniero Industrial",
				"Agrónomo",
				"Ingeniero Civil",
				"Gerente de Area",
				"Ingeniero Eléctrico",
				"Asesor Legal",
				"Analista de Reclamos de Seguros",
				"Consultor",
				"Jefe o Encargado Técnico | Proyecto",
				"Asistente Técnico/Proyecto",
				"Ingeniero Químico",
				"Ingeniero Mecánico",
				"Encargado de Estadísticas",
				"Gerente Técnico | Proyecto",
				"Ingeniero Biomédico",
				"Biologo",
				"Corredor de Seguros",
				"Diseñador Industrial",
				"Gerente de Obras Civiles",
				"Arquitecto",
				"Jefe o Encargado Legal",
				"Sicólogo"
			],
			"6": [
				"Supervisor de Producción",
				"Gerente de Producción | Planta",
				"Jefe o Encargado de Seguridad Industrial",
				"Auditor de Calidad",
				"Asistente de Ingeniería",
				"Operario de Producción",
				"Asistente de Control de Calidad",
				"Jefe de Producción",
				"Oficial de Seguridad Industrial",
				"Supervisor de Calidad",
				"Asistente de Producción",
				"Ingeniero de Planta y Proceso",
				"Asistente de Laboratorio",
				"Jefe de Control de Calidad",
				"Jefe de Ingeniería de Procesos",
				"Gerente de Ingeniería",
				"Jefe de Procesos o Sección",
				"Director de Producción",
				"Gerente de Control de Calidad",
				"Gerente de Seguridad Industrial",
				"Jefe de Planificación de la Producción",
				"Tecnólogo en Alimentos",
				"Técnico de Lubricación | Predictivo"
			],
			"7": [
				"Ejecutivo de Servicio al Cliente",
				"Diseñador Gráfico",
				"Coordinador de Eventos",
				"Jefe de Servicio al Cliente",
				"Community Manager",
				"Asistente de Publicidad",
				"Gerente de Comunicaciones | Relaciones Públicas",
				"Jefe de Comunicaciones",
				"Reportero",
				"Jefe de marca"
			],
			"8": [
				"Administrador",
				"Asistente Administrativo",
				"Asistente de Gerencia",
				"Gerente Administrativo",
				"Jefe Administrativo",
				"Analista de Organización y Métodos",
				"Asistente a la Presidencia | Gerencia General",
				"Jefe de Area",
				"Gerente General | Director Ejecutivo",
				"Jefe de Planificación",
				"Sub Gerente General"
			],
			"9": [
				"Asistente de Recursos Humanos",
				"Generalista de Recursos Humanos",
				"Reclutador",
				"Jefe o Encargado de Capacitación",
				"Encargado de Reclutamiento",
				"Gerente de Recursos Humanos",
				"Encargado de Compensaciones",
				"Gerente de Desarrollo Humano",
				"Jefe de Reclutamiento y Selección",
				"Encargado de Desarrollo Organizacional",
				"Asistente de Desarrollo Humano",
				"Analista de Estudios Socioeconómicos"
			],
			"10": [
				"Cajero Bancario",
				"Ejecutivo de Cuenta",
				"Otros Puestos Bancarios",
				"Analista de Crédito",
				"Jefe de Agencia | Sucursal",
				"Ejecutivo Corporativo",
				"Ejecutivo Pyme",
				"Ejecutivo de Afiliación | Tarjeta de Crédito",
				"Gerente de Agencia | Sucursal",
				"Oficial de Cumplimiento",
				"Gerente de Operaciones Financieras",
				"Gestor de Riesgo",
				"Gerente Legal",
				"Gerente de Crédito",
				"Gerente de Finanzas"
			],
			"11": [
				"Asistente de Operaciones",
				"Jefe o Encargado de Operaciones y Logística",
				"Asistente de Exportaciones | Importaciones",
				"Facturador",
				"Jefe o Encargado de Transporte | Tráfico",
				"Gerente de Operaciones",
				"Agente Aduanero | Tramitador Aduanal",
				"Gerente de Operaciones y Logística",
				"Jefe de Servicios Generales",
				"Jefe o Encargado de Exportaciones | Importaciones",
				"Jefe o Encargado de Despacho y | o Recepción",
				"Planificador de Nave"
			],
			"12": [
				"Mensajero",
				"Recepcionista",
				"Oficial de Seguridad",
				"Cobrador",
				"Jefe de Seguridad",
				"Auxiliar General de Servicio",
				"Digitador",
				"Asistente de Oficina",
				"Recepcionista Bilingüe",
				"Secretaria de Area | Departamento",
				"Secretaria Ejecutiva",
				"Secretaria Ejecutiva Bilingue",
				"Secretaria de Gcia. General | Presidencia"
			],
			"13": [
				"Chofer",
				"Otros empleos",
				"Investigador Privado",
				"Operador de Equipo Pesado",
				"Trabajador Social",
				"Valet Parking",
				"Ninera",
				"Plomero",
				"Trainee",
				"Ama de Llaves",
				"Cosmetólogo",
				"Ebanista",
				"Entrenador",
				"Guía Turístico",
				"Traductor | intérprete "
			],
			"14": [
				"Repartidor",
				"Cocinero",
				"Jefe de Alimentos y Bebidas",
				"Mesero",
				"Gerente de Restaurante",
				"Asistente de Cocina",
				"Panadero",
				"Barista",
				"Bartender",
				"Hostess",
				"Jefe de Cocina",
				"Jefe de Restaurante",
				"Chef"
			],
			"15": [
				"Servicio al cliente - Español",
				"Servicio al cliente - Inglés",
				"otro",
				"Agente de Ventas",
				"Agente de Servicio",
				"Ejecutivo de Call Center",
				"Jefe o Encargado de Call Center",
				"Agente de Soporte",
				"Gerente de Call Center",
				"Agente de Calidad",
				"Auditor de Calidad",
				"Coordinador de Calidad",
				"Gerente de Calidad",
				"Lider de Equipo"
			],
			"16": [
				"Farmacéutico",
				"Enfermero Profesional | Auxiliar de Paramédico",
				"Visitador Médico",
				"Médico",
				"Odontólogo",
				"Optometrista",
				"Regente",
				"Veterinario",
				"Medico Maxilofacial",
				"Dermatologo",
				"Psicologo"
			],
			"17": ["Asistente de Compras", "Comprador", "Jefe de Compras", "Encargado de Licitaciones", "Gerente de Compras "],
			"18": ["Técnico/Ing en Telecomunicaciones", "Técnico en Redes", "Gerente de Telecomunicaciones", "Jefe o Encargado de Proyectos"],
			"19": ["Cualquiera"],
			//"20": ['Cualquiera/Bodega'],
			"21": [
				"Asistente de Operaciones",
				"Jefe o Encargado de Operaciones y Logística",
				"Asistente de Exportaciones | Importaciones",
				"Facturador",
				"Jefe o Encargado de Transporte | Tráfico",
				"Gerente de Operaciones",
				"Agente Aduanero | Tramitador Aduanal",
				"Gerente de Operaciones y Logística",
				"Jefe de Servicios Generales",
				"Jefe o Encargado de Exportaciones | Importaciones",
				"Jefe o Encargado de Despacho y | o Recepción",
				"Planificador de Nave"
			],
			"22": ["Auxiliar de Bodega", "Jefe de Bodega", "Asistente de Inventarios", "Jefe de Inventario", "Bodeguero", "Montacarguista"],
			"23": ["Piloto Particular", "Piloto Vehículos Pesados", "Piloto Motocicletas", "Piloto Vehículos de Seguridad"],
			"24": ["Mecánico | eléctricista | Soldador"],
			"25": ["Cualquiera/Facturador"],
			"26": ["Cualquiera/Seguridad"],
			"27": ["Cualquiera/Limpieza"],
			"28": ["Cualquiera/Entretenimiento"],
			"29": ["Abogado", "Notario", "procurador", "Traductor Jurado"],
			"30": ["Decorador | Diseñador de Interiores", "Diseñador de Vestuario | Textil | Modas", "Dibujante", "Diseñador Gráfico"],
			"31": ["Catedratico Universitario", "Profesor de enseñaza media", "Profesor de parvulos", "Bibliotecario", "Maestro de Inglés"],
			"32": [
				"Médico General",
				"Cirujano Plástico",
				"Anestesiología",
				"Cirugía General",
				"Cirugía Oral y Maxilofacial",
				"Ginecología Obstetricia",
				"Medicina Física y Rehabilitación",
				"Medicina Interna",
				"Patología",
				"Pediatría",
				"Psiquiatría",
				"Traumatología y Ortopedia"
			],
			"33": ["Hoteleria", "Turismo"]
		},
		rubros_academy: {
			"58": ["Primaria"],
			"1": ["Primero Básico", "Segundo Básico", "Tercero Básico"],
			"2": [
				"Cocinero Internacional",
				"Community Manager",
				"Cultor de Belleza",
				"Electricista instalador domiciliar",
				"Electricista instalador industrial",
				"Enderezador y pintor de automóviles",
				"Esteticista",
				"Estilista",
				"Guía general de turistas",
				"Mecánico automotriz gasolina",
				"Mecánico de mantenimiento industrial",
				"Mecánico de motocicletas",
				"Mecánico de rectificación de motores de combustión interna",
				"Mecánico de refrigeración y aire acondicionado",
				"Repostero internacional",
				"Soldador industrial",
				"Técnico en administración de redes y telecomunicaciones",
				"Técnico en desarrollo y mantenimiento de internet de las cosas (IoT)",
				"Técnico en diseño industrial del vestuario",
				"Técnico en diseño web",
				"Técnico en electricidad industrial",
				"Técnico en electromecánica industrial",
				"Técnico en electrónica industrial",
				"Técnico en hotelería y turismo",
				"Técnico en mantenimiento industrial",
				"Técnico en mecánica automotriz",
				"Técnico en mecánica del tractor agrícola",
				"Técnico en mecánica diésel",
				"Técnico en mecánica industrial",
				"Técnico en mecatrónica",
				"Técnico en operaciones bancarias",
				"Técnico en procesamiento industrial de alimentos",
				"Técnico en refrigeración y aire acondicionado",
				"Técnico en reparación y soporte de sistemas informáticos",
				"Técnico en seguros",
				"Técnico en soldadura industrial",
				"Técnico en soporte de infraestructura de redes y telecomunicaciones"
			],
			"3": [
				"Bachillerato en ciencias y letras con orientación en computación",
				"Bachillerato en ciencias y letras con orientación en diseño gráfico",
				"Bachillerato en ciencias y letras con orientación en electricidad",
				"Bachillerato en ciencias y letras con orientación en ciencias biológicas",
				"Bachillerato en ciencias y letras con orientación en educación",
				"Bachillerato en ciencias y letras con orientación en productividad y desarrollo",
				"Bachillerato en ciencias y letras con orientación en educación física",
				"Bachillerato en ciencias y letras con orientación en educación musical",
				"Bachillerato en ciencias y letras con orientación en finanzas y administración",
				"Bachillerato en ciencias y letras con orientación en gestión de oficinas",
				"Bachillerato en ciencias y letras con orientación en mecánica automotriz",
				"Bachillerato en ciencias y letras con orientación en textiles",
				"Bachillerato en ciencias y letras con orientación en turismo",
				"Bachillerato en construcción",
				"Bachillerato en mercadotecnia",
				"Bachillerato industrial con especialidad en belleza",
				"Bachillerato industrial y perito en construcción",
				"Bachillerato en ciencias y letras con orientación en artes plásticas",
				"Bachillerato en ciencias y letras y secretariado bilingüe",
				"Bachillerato en computación con orientación científica",
				"Bachillerato en diseño gráfico",
				"Bachillerato en turismo y hotelería",
				"Bachillerato industrial y perito en radio y televisión",
				"Bachillerato industrial con especialidad en costura industrial y cocina",
				"Bachillerato industrial y perito en dibujo de arquitectura e ingeniería",
				"Bachillerato industrial y perito en electrónica",
				"Bachillerato por Madurez",
				"Bachillerato en ciencias y letras",
				//
				"Bachillerato en ciencias y letras por madurez",
				"Bachillerato en ciencias y letras con orientacion en mecanica automotr",
				"Bachillerato en ciencias y letras con orientacion en educacion",
				"Bachillerato en ciencias y letras con orientacion en educacion fisica",
				"Bachillerato en ciencias y letras con orient en agronomia",
				"Bachillerato en ciencias y letras y auxiliar de enfermeria",
				"Bachillerato en ciencias y letras con diplomado en medicina",
				"Bachillerato en ciencias y letras con orientacion agroforestal",
				"Bachillerato en ciencias y letras con orientacion cientifica",
				"Perito en mecanografía",
				"Normal preprimaria",
				"Normal primaria",
				"Normal primaria urbana",
				"Normal primaria rural",
				"Normal de educacion musical",
				"Normal de educacion fisica",
				"Normal educacion para el hogar",
				"Perito contador",
				"Secretariado y oficinista",
				"Secretariado bilingue",
				"Perito en administracion publica",
				"Bachillerato en mercadotecnia",
				"Perito en mercadotecnia y publicidad",
				"Bachillerato industrial y perito en dibujo de construccion",
				"Perito industrial",
				"Bachillerato en mecanica general",
				"Bachillerato en construccion",
				"Bachillerato en ciencias de la comunicacion",
				"Bachillerato en computacion",
				"Perito en tecnicas de desarrollo comunitario",
				"Perito en tecnicas policiales",
				"Perito en administracion comercial",
				"Perito en gerencia administrativa",
				"Secretariado ejecutivo",
				"Secretariado ejecutivo bilingue",
				"Perito en ciencias de la comunicacion",
				"Perito en administracion de empresas",
				"Secretariado ejecutivo bilingue con espec. en merc. y pub.",
				"Perito contador con especialidad en computacion",
				"Perito en agricultura",
				"Bachillerato en cosmetologia",
				"Bachillerato en admon indust. y perito en alguna espec.",
				"Bachillerato en recursos naturales renovables",
				"Perito en relaciones publicas empresariales",
				"Bachillerato en hoteleria y hogar",
				"Secretariado con orientacion juridica",
				"Perito contador en computacion",
				"Perito en higiene dental",
				"Bachillerato en dibujo tecnico y de construccion",
				"Bachillerato en ciencias y humanidades",
				"Secretariado comercial con especialidad en computacion",
				"Secretariado bilingue con especialidad en computacion",
				"Normal de educacion primaria bilingue",
				"Bachillerato en computacion con orientacion cientifica",
				"Magisterio bilingue con orientacin en desarrollo comunitario",
				"Secretariado y oficinista con especialidad en computacion",
				"Perito en ciencias turisticas",
				"Perito en electricidad",
				"Perito en mecanica automotriz",
				"Normal primaria con orientacion ambiental",
				"Perito en administracion de empresas con orientacion en comp",
				"Secretariado comercial y oficinista tecnico",
				"Bachillerato en tecnicas para el desarrollo comunitario",
				"Normal preprimaria bilingue",
				"Bachillerato en computacion con orientacion comercial",
				"Bachillerato en turismo y hoteleria",
				"Perito en dibujo de construccion",
				"Perito contador con especialidad en computacion comercial",
				"Bachillerato en publicidad",
				"Secretariado bilingue con orienta.turismo y hoteleria",
				"Perito en administracion turistica y hotelera",
				"Bachillerato en dibujo de construccion con orientacion en computacion",
				"Perito en electronica con orientacion en computacion",
				"Bachillerato industrial y perito en mecanica automotriz",
				"Bachillerato industrial y perito en electronica industrial",
				"Secretariado comercial",
				"Bachillerato en filosofia y teologia",
				"Perito en mecanica general (tornos)",
				"Perito en radio y television",
				"Secretario contador",
				"Bachillerato en turismo con especialidad en computacion",
				"Bachillerato industrial y perito en computacion",
				"Bachillerato en turismo y lineas aereas",
				"Bachillerato industrial y perito en electricidad",
				"Bachillerato en construccion y dibujo computarizado",
				"Bachillerato industrial en electronica digital y microprocesa",
				"Secretariado ejecutivo en espanol",
				"Bachillerato industrial y perito en elecricidad",
				"Bachillerato indus y perito en costura industrial",
				"Bachillerato industrial",
				"Secretariado ejecutivo bilingue con orienta. comp.comercial",
				"Secretariado ejecutivo en computacion",
				"Secretariado comercial y oficinista",
				"Bachillerato agricola y computacion",
				"Perito en mercadotecnia y pub. diplomado en compu. comercial",
				"Perito en la enseñanza de mecanografia",
				"Bach. industrial, perito en electricidad y mecanica automot.",
				"Perito en electronica y microprocesadores",
				"Bachillerato industrial y perito en una especialidad",
				"Bachillerato en electronica",
				"Bachillerato industrial con una especialidad",
				"Bachillerato industrial y perito en electronica digi y micro",
				"Perito contador bilingue (español-ingles)",
				"Bachillerato bilinguen en ciencias y humanidades",
				"Bachillerato en admon industrial p. en dibujo de construccio",
				"Bachillerato en admon. indus y p. en electricidad",
				"Perito en admon. publica con orientacion en computacion.",
				"Perito contador con orientacion artesanal y computacion",
				"Bachillerato agro-industrial y perito en tecnicas azucareras",
				"Bachillerato en agricultura",
				"Perito agronomo",
				"Bachillerato en dibujo tecnico y construcion con computacion",
				"Perito cont. con esp. en admon. de pequeñas empresas agric.",
				"Bachillerato en mecanica general",
				"Perito en recursos naturales renovables",
				"Secretariado bilingue orientacion turismo-agencia de viajes",
				"Bachillerato en diseño grafico",
				"Tecnico en desarrollo comunitario",
				"Secretariado bilingue con orientacion en computacion",
				"Perito en deportes",
				"Bach.ind.y per. en electronica,electricidad y mec.autom.",
				"Tecnico en administracion de proyectos",
				"Perito en ciencias ambientales",
				"Perito contador con orientacion en computacion comercial",
				"Magisterio de educ. primaria con instruccion tecnica",
				"Bachillerato indust. y perito en diseño grafico.",
				"Perito en construccion y dibujo de ingenieria",
				"Secretariado comercial con orientacion en computacion",
				"Secretariado y oficinista con orientacion en computacion",
				"Normal artes plasticas",
				"Secretariado trilingue con orient en comercio internacional",
				"Secret bilingue con orient en idiomas diplomacia y rel inter",
				"Tecnico en educacion alternativa",
				"Perito en administracion bancaria diplomado en computacion",
				"Bachillerato en diseño de modas",
				"Bachillerato en diseño de interiores",
				"Bachillerato industrial y perito en dibujo de arquitectura e ingenieri",
				"Bachillerato en telecomunicaciones",
				"Magisterio pre-primaria bilingue intercultural",
				"Magisterio primaria bilingue intercultural",
				"Perito contador con orientacion en administracion portuaria",
				"Perito contador con orientacion en computacion",
				"Mecanica en mantenimiento de aeronaves",
				"Perito forestal",
				"Secretaria bilingue espe. en admon turistica y lineas aereas",
				"Bachillerato en arte especializado en actuacion",
				"Bach. industrial y perito en mecanica en mantenimiento industrial",
				"Perito en ecoturismo",
				"Perito en administracion",
				"Magisterio de educacion infantil bilingue intercultural",
				"Magisterio de educacion infantil intercultural",
				"Magisterio primaria urbana bilingue intercultural",
				"Perito en informatica",
				"Bachillerato industrial y perito en mecanica diesel",
				"Bachillerato industrial y perito en electronica",
				"Magisterio de educacion primaria intercultural",
				"Bachillerato industrial y perito en construccion",
				"Perito en industria alimentaria",
				"Bachiller industrial y perito en diseño de modas",
				"Bachillerato en hoteleria y turismo",
				"Bachillerato industrial y perito en alguna especialidad",
				"Bachillerato General Unificado"
			],
			"4": ["Magisterio en educación infantil bilingüe intercultural", "Magisterio en educación infantil intercultural", "Magisterio normal preprimaria"],
			"5": [
				"Perito con especialidad en Electricidad Industrial",
				"Perito con Especialidad en Electrónica Industrial",
				"Perito contador",
				"Perito contador bilingüe",
				"Perito contador con especialidad en administración de pequeñas empresas",
				"Perito contador con orientación en computación",
				"Perito en administración",
				"Perito en administración pública",
				"Perito en Cocina Internacional",
				"Perito en desarrollo comunitario",
				"Perito en electricidad industrial",
				"Perito en Electromecánica Industrial",
				"Perito en electrónica y dispositivos digitales",
				"Perito en industria de alimentos",
				"Perito en Mantenimiento Industrial",
				"Perito en Mecánica Automotriz",
				"Perito en Mecánica Diesel",
				"Perito en Mecánica Industrial",
				"Perito en Mecatrónica",
				"Perito en mercadotecnia y publicidad",
				"Perito en Procesamiento Industrial de Alimentos",
				"Perito en Refrigeración y Aire Acondicionado",
				"Perito en Soldadura Industrial",
				"Perito en Ventas y Soporte Administrativo",
				"Perito en Turismo"
			],
			"6": [
				"Secretariado bilingüe",
				"Secretariado bilingüe con orientación en computación",
				"Secretariado y oficinista",
				"Secretariado comercial y oficinista",
				"Secretariado ejecutivo y bilingüe",
				"Secretariado y oficinista con orientación jurídica"
			],
			"7": [
				"Ingeniería Agrícola con énfasis en Gerencia",
				"Ingeniería Agronómica en Recursos Naturales Renovables",
				"Ingeniería Agronómica en Sistemas de Producción Agricola",
				"Ingeniería Ambiental con énfasis en Gestión",
				"Ingeniería en Gestión Ambiental Local",
				"Ingeniería en Industrias Agropecuarias y Forestales",
				"Licenciatura en Agronegocios Internacionales"
			],
			"8": [
				"Arquitectura",
				"Arquitectura de interiores",
				"Licenciatura en Diseño Gráfico",
				"Licenciatura en Diseño Industrial del Vestuario",
				"Licenciatura en Diseño de Ambientes",
				"Licenciatura en Diseño Digital Interactivo",
				"Licenciatura en Diseño de Producto"
			],
			"9": [
				"Licenciatura en Administración Aduanera y Comercio Internacional",
				"Licenciatura en Administración de Empresas",
				"Licenciatura en Administración de Hoteles y Restaurantes",
				"Licenciatura en Administración en Hotelería, Turismo y Gastronomía",
				"Licenciatura en Administración Pública",
				"Licenciatura en Administración y Dirección de Negocios",
				"Licenciatura en Administración y Finanzas",
				"Licenciatura en Comercio Internacional",
				"Licenciatura en Contaduría Pública y Auditoría",
				"Licenciatura en Economía con Énfasis en Riesgos Financieros",
				"Licenciatura en Economía Empresarial",
				"Licenciatura en Economía Global",
				"Licenciatura en Gerencia de Negocios y Servicios",
				"Licenciatura en Gestión Aduanera y Comercio Internacional",
				"Licenciatura en Marketing",
				"Licenciatura en Mercadotecnia"
			],
			"10": ["Ciencias Criminológicas y Criminalísticas"],
			"11": [
				"Licenciatura en Ciencias Jurídicas y de la Justicia",
				"Licenciatura en Ciencias Jurídicas y Sociales, Abogacía y Notariado",
				"Licenciatura en Investigación Criminal y Forense",
				"Técnico Universitario en Investigación Criminal y Forense"
			],
			"12": ["Médico y Cirujano"],
			"13": ["Licenciatura en Enfermería", "Técnico en Enfermería"],
			"14": ["Técnico de Fisioterapia", "Técnico de Terapia Respiratoria", "Licenciatura en Fisioterapia"],
			"15": [
				"Licenciatura en Alimentación y Nutrición",
				"Licenciatura en Biología",
				"Licenciatura en Bioquímica y Microbiología",
				"Licenciatura en Biotecnología Molecular",
				"Licenciatura en Nutrición",
				"Licenciatura en Nutrición y Gastronomía",
				"Licenciatura en Nutrición y Salud Pública",
				"Licenciatura en Química",
				"Licenciatura en Química Biológica",
				"Licenciatura en Química Farmaceútica",
				"Licenciatura en Química Farmacéutica con Especialidad en Industria y Atención Farmacéutica"
			],
			"16": [
				"Licenciatura en Administración de Empresas Cosméticas y Servicios Estéticos",
				"Licenciatura en Administración de Sistemas de Emergencia",
				"Licenciatura en Administración y Gerencia de Servicios de Salud",
				"Licenciatura en Ciencia y Tecnología de Alimentos",
				"Licenciatura en Enfermería",
				"Licenciatura en Fisioterapia",
				"Licenciatura en Gatronomía y Administración Culinaria",
				"Licenciatura en Gestión Empresarial",
				"Licenciatura en Optometría",
				"Licenciatura en Química Biológica",
				"Licenciatura en Medicina",
				"Licenciatura en Nutrición",
				"Licenciatura en Terapia Respiratoria",
				"Técnico Universitario en Terapia Respitaroria"
			],
			"17": [
				"Licenciatura en Arte",
				"Licenciatura en Ciencias de la Comunicación",
				"Licenciatura en Educación Inicial y Preprimaria",
				"Licenciatura en Educación y Aprendizaje",
				"Licenciatura en Filosofía",
				"Licenciatura en Letras y Filosofía",
				"Licenciatura en Psicología Clínica",
				"Licenciatura en Psicología Industrial/Organizacional",
				"Profesorado de Enseñanza Media en Artes Plásticas e Historia del Arte",
				"Profesorado de Enseñanza Media en Educación Musical",
				"Profesorado de Enseñanza Media en Filosofía",
				"Profesorado de Enseñanza Media en Idioma Inglés",
				"Profesorado de Enseñanza Media en Lengua y Literatura",
				"Profesorado de Enseñanza Media en Pedagogía y Promotor de Derechos Humanos y Cultura de Paz",
				"Profesorado de Enseñanza Media en Pedagogía y Técnico en Administración Educativa",
				"Profesorado de Enseñanza Media en Pedagogía, Ciencias Sociales y Formación Ciudadana",
				"Profesorado en Ciencias de Información",
				"Profesorado en Educación a Distancia",
				"Profesorado en Pedagogía y Tecnología de la Información y la Comunicación",
				"Técnico en Ciencias de la Información",
				"Técnico en Restauración de Bienes Muebles"
			],
			"18": [
				"Ingeniera Industrial",
				"Ingeniería Administrativa",
				"Ingeniería Agroindustrial",
				"Ingeniería Ambiental",
				"Ingeniería Bioinformática",
				"Ingeniería Biomédica",
				"Ingeniería Biotecnología Industrial",
				"Ingeniería Ciencias de Alimentos",
				"Ingeniería Ciencias de los Datos",
				"Ingenieria Civil",
				"Ingeniería Civil Ambiental",
				"Ingeniería Civil Arquitectónica",
				"Ingeniería Civil Industrial",
				"Ingeniería Comercial",
				"Ingeniería Computación y Tecnologías de la Información",
				"Ingeniería de Alimentos",
				"Ingeniería de la Construcción",
				"Ingeniería de Sistemas, Informática y Ciencias de la Computación",
				"Ingeniería Eléctrica",
				"Ingeniería Electrónica",
				"Ingeniería en Sistemas e Informática",
				"Ingeniería en Electrónica y Telecomunicaciones",
				"Ingeniería en Industria Alimentaria",
				"Ingeniería en Industria del Bosque",
				"Ingeniería en Telecomunicaciones y Redes Teleinformáticas",
				"Ingeniería Mecánica",
				"Ingeniería Mecánica Eléctrica",
				"Ingeniería Mecánica Industrial",
				"Ingeniería Mecatrónica",
				"Ingeniería Química",
				"Ingeniería Química Industrial",
				"Ingeniería Tecnología de Audio"
			],
			"19": ["Cirujano Dentista"],
			"20": ["Medicina Veterinaria", "Zootecnia"],
			"21": [
				"Licenciatura en Orientación Vocacional y Laboral",
				"Licenciatura en Psicología",
				"Licenciatura en Psicología Clínica y Consejería Social",
				"Licenciatura en Psicología Educativa",
				"Licenciatura en Psicología Industrial",
				"Licenciatura en Psicología Organizacional y Gestión del Talento Humano",
				"Licenciatura en Psicopedagogía",
				"Licenciatura en Terapia del Lenguaje",
				"Licenciatura en Terapia Ocupacional y Recreativa",
				"Licenciatura en Trabajo Social con Enfoque en Desarrollo Sostenible"
			],
			"22": [
				"Licenciatura en Antropología",
				"Licenciatura en Arqueología",
				"Licenciatura en Historia",
				"Licenciatura para la Enseñanza de la Historia",
				"Profesorado de Enseñanza Media en Historia y Ciencias Sociales",
				"Ténico Universitario en Archivos"
			],
			"23": [
				"Licenciatura en Trabajo Social",
				"Técnico en Gestión de los Sistemas de Protección Social",
				"Técnico en Gestión Social para la Atención de la Primera Infancia",
				"Técnico Universitario en Trabajo Social"
			],
			"24": [
				"Licenciatura en Ciencias de la Comunicación",
				"Licenciatura en Ciencias de la Comunicación con Énfasis en Locución",
				"Licenciatura en Ciencias de la Comunicación con Énfasis en Periodismo",
				"Licenciatura en Ciencias de la Comunicación con Énfasis en Publicidad",
				"Licenciatura en Comunicación y Diseño",
				"Licenciatura en Comunicación y Producción Audiovisual",
				"Licenciatura en Comunicación y Tecnología Digital",
				"Licenciatura en Diseño Gráfico",
				"Licenciatura en Diseño Y Animación Digital",
				"Licenciatura En Producción De Audio y Música Digital Con Énfasis En Music Business",
				"Locución Profesional",
				"Periodismo Profesional",
				"Publicidad Profesional"
			],
			"25": ["Licenciatura en Ciencia Política", "Licenciatura en Sociología", "Licenciatura en Relaciones Internacionales"],
			"26": [
				"Licenciatura en Administración Educativa",
				"Licenciatura en Educación Bilingüe Intercultural con Énfasis en la Cultura Maya",
				"Licenciatura en Educación de Historia y Ciencias Sociales",
				"Licenciatura en Educación de Informática y Ciencias de la Computación",
				"Licenciatura en Educación del Lenguaje y Comunicación",
				"Licenciatura en Educación Inicial y Pre-primaria",
				"Licenciatura en Educación Primaria",
				"Licenciatura en la Educación a Personas con Discapacidad Sensorial y de la Comunicación",
				"Licenciatura en la Enseñanza de la Matemática y física",
				"Licenciatura en la Enseñanza de la Química y Biología",
				"Licenciatura en la Enseñanza de las Ciencias Económico Contables",
				"Licenciatura en la Enseñanza del Idioma Español y Literatura",
				"Licenciatura en Psicopedagogía y Problemas de Aprendizaje",
				"Profesorado de Enseñanza Media en Computación e Informática",
				"Profesorado de Enseñanza Media en Educación Bilingüe Intercultural",
				"Profesorado de Enseñanza Media en Matemática y Física",
				"Profesorado en Educación de la Informática y Ciencias de la Computación",
				"Profesorado en Educación Inicial y Pre-primaria",
				"Profesorado en Educación Media en Lenguaje y Comunicación",
				"Profesorado en Enseñanza Media con Especialización",
				"Profesorado en Enseñanza Media de la Historia y las Ciencias Sociales",
				"Profesorado en Enseñanza Media en Química y Biología",
				"Profesorado en Productividad y Desarrollo (FID)",
				"Técnico Universitario en Calidad Educativa",
				"Técnico Universitario en Trastornos de Aprendizaje y Psicopedagogía"
			],
			"27": [
				"Licenciatura en Educación",
				"Licenciatura en Educación con Orientación en Educación Preprimaria",
				"Licenciatura en Pedagogía y Administración Educativa",
				"Licenciatura en Pedagogía y Desarrollo Educativo",
				"Profesorado de Enseñanza Media en Educación Física",
				"Profesorado de Enseñanza Media en Psicología",
				"Profesorado en Educación Especial",
				"Técnico en Deportes"
			],
			"28": ["Técnico en Traducción y Correspondencia Internacional", "Licenciatura en Ciencias Linguisticas con Especialidad en Traducción e Interpretación"],
			"29": [
				"Licenciatura en Arte Dramático con Especialidad en Actuación",
				"Licenciatura en Artes Visuales con Especialidad en Pintura",
				"Licenciatira en Danza Contemporánea y Coreografía",
				"Licenciatura en Música"
			],
			"30": ["Licenciatura en Física Aplicada", "Licenciatura en Matemática Aplicada"],
			"31": [
				"Técnico en Aseguramiento de la Calidad para la Industria Farmacéutica y Alimenticia",
				"Técnico en Visagismo del Cabello, Estilo e Imagen",
				"Técnico Universitario en Atención de Adicciones",
				"Técnico Universitario en Ciencia y Tecnología de Alimentos",
				"Técnico Universitario en Cuidados Geriátricos",
				"Técnico Universitario en Electrónica",
				"Técnico Universitario en Enfermería",
				"Técnico Universitario en Enfermería Veterinaria",
				"Técnico Universitario en Gastronomía y Administración Culinaria",
				"Técnico Universitario en Hemodiálisis",
				"Técnico Universitario en Hemoterapia e Inmunohematología",
				"Técnico Universitario en Laboratorio Clínico",
				"Técnico Universitario en Mantenimiento Automotriz",
				"Técnico Universitario en Metal Mecánica",
				"Técnico Universitario en Optometría",
				"Técnico Universitario en Partería Profesional con Enfoque Intercultural",
				"Técnico Universitario en Procesos de Manufactura",
				"Técnico Universitario en Procesos Productivos y Calidad Alimentaria",
				"Técnico Universitario en Radiología e Imágenes Diagnósticas",
				"Técnico Universitario en Refrigeración y Aire Acondicionado",
				"Técnico Universitario en Repostería Profesional",
				"Técnico Universitario en Salud y Seguridad Ocupacional",
				"Técnico Universitario en Tecnología en Ciencias del Esteticismo",
				"Técnico Universitario en Urgencias Médicas y Cuidados Intensivos",
				"Técnico Universitario en Visita Médica y Mercadeo"
			],
			"32": ["Composición y Producción Musical", "Diseño de Producto e Innovación"],
			"33": ["Licenciatura en Ciencia y Tecnología del Deporte", "Licenciatura en Gestión de Entidades Deportivas"],
			"34": ["Food Business and Marketing", "International Marketing and Business Analytics"],
			"35": [
				"Maestría en Control Tecnológico y Ciberseguridad",
				"Maestría en Electrónica Industrial",
				"Maestría en Gestión y Dirección de Proyectos",
				"Maestría en Informática con Énfasis en Banca Electrónica y Comunicaciones",
				"Maestría en Ingeniería Biomédica",
				"Maestría en Ingeniería con Especialidad en Administración de Operaciones y Cadena de Suministro",
				"Maestría en inteligencia de negocios, analítica y ciencia de los datos",
				"Maestría en Investigación de Operaciones",
				"Maestría en Tecnologías de la Información",
				"Postgrado en Bases de Datos",
				"Postgrado en Emprendimiento e Innovación Tecnológica",
				"Postgrado en Redes de Computadoras",
				"Postgrado en Seguridad Informática",
				"Postgrado en Sistemas de Información",
				"Postgrado en Telecomunicaciones"
			],
			"36": [
				"Maestría en Administración con Especialización en Mercadeo",
				"Maestría en Administración de la Calidad",
				"Maestría en Administración de Negocios",
				"Maestría en Administración Financiera",
				"Maestría en Administración Pública",
				"Maestría en Alta Dirección Política y Administración Pública (Ejecutiva)",
				"Maestría en Análisis y Administración de Confiabilidad",
				"Maestría en Derecho Tributario Empresarial",
				"Maestría en Gerencia de Comercio Internacional y Aduanas",
				"Maestría en Gestión Humana y Desarrollo Organizacional",
				"Maestría en Gestión y Desarrollo del Recurso Humano",
				"Maestría en Productividad en Ciencias Agrícolas",
				"Maestría en Reingeniería y Tecnologías de Aseguramiento",
				"Postgrado en Administración de Empresas Agrícolas",
				"Postgrado en Administración de Negocios",
				"Postgrado en Administración de Recursos Humanos",
				"Postgrado en Mercadeo Gerencial y Estratégico",
				"Postgrado en Planeación y Aseguramiento de la Calidad"
			],
			"37": [
				"Maestría en Coaching Nutricional y Nuevos Enfoques de Atención",
				"Maestría en Epidemiología",
				"Maestría en Gestión Ambiental y Sostenibilidad",
				"Maestría en Nutrición en la Actividad Física y el Deporte",
				"Postgrado en Formación de Auditores en Buenas Prácticas de Manufactura Farmacéutica"
			],
			"38": [
				"Maestría en Administración y Economía con Énfasis en Finanzas",
				"Maestría en Currículo y Tecnología Educativa",
				"Maestría en Dirección y Gestión Estratégica de Empresas Turísticas",
				"Maestría en Docencia Superior e Innovación",
				"Maestría en Educación Virtual",
				"Maestría en Gerencia Educativa",
				"Maestría en Innovación y Docencia Superior",
				"Maestría en líderazgo y Coaching Educativo",
				"Maestría en Medición, Evaluación e Investigación Educativa",
				"Maestría en Planeación y Gerencia Educativa",
				"Maestría en Psicopedagogía"
			],
			"39": ["Maestría en Administración Hospitalaria", "Maestría en Biología Molecular", "Maestría en Nutrición y Desarrollo Humano", "Maestría en Productividad en Ciencias de la Salud"],
			"40": ["Maestría en Administración de Proyectos de Construcción"],
			"41": [
				"Maestría en Administración de Sistemas de Emergencia",
				"Maestría en Anestesia y Medicina del Dolor",
				"Maestría en Atención Integral del VIH (virtual)",
				"Maestría en Ciencias en Adicciones (semi-presencial )",
				"Maestría en Cirugía General",
				"Maestría en Cuidados Paliativos (virtual)",
				"Maestría en Dirección Ejecutiva de Hospitales",
				"Maestría en Educación en Ciencias de la Salud",
				"Maestría en Endodoncia e Implantes",
				"Maestría en Geriatría y Gerontología",
				"Maestría en Gestión de la Salud y Seguridad en el Trabajo",
				"Maestría en Gestión de la Seguridad Alimentaria y Nutricional",
				"Maestría en Gestión de Sistemas de Salud",
				"Maestría en Gestión y Administración de Servicios de Salud",
				"Maestría en Ginecología y Obstetricia",
				"Maestría en Medicina Familiar",
				"Maestría en Medicina Interna",
				"Maestría en Oftalmología Integral",
				"Maestría en Pediatría",
				"Maestría en Planeación y Gestión Políticas y Programas de Alimentación Infantil (virtual)",
				"Maestría en Prostodoncia con Énfasis en Estética Dental",
				"Maestría en Radiología y Diagnóstico por Imágenes",
				"Maestría en Rehabilitación Oral",
				"Maestría en Salud Pública Veterinaria",
				"Postgrado en Ciencias del Comportamiento, Estudio e Investigación del Ser Humano",
				"Postgrado en Formación de Auditores en Buenas Prácticas de Manufactura Farmacéutica",
				"Postgrado en Medicina de Emergencias",
				"Maestría en alimentación y nutrición"
			],
			"42": [
				"Maestría en Administración de Negocios",
				"Maestría en Administración Corporativa",
				"Maestría en Consultoría Tributaria",
				"Maestría en Dirección y Gestión Financiera",
				"Maestría en Economía",
				"Maestría en Finanzas Empresariales con (Doble titulación)",
				"Maestría en Gerencia Comercial y Marketing estratégico",
				"Maestría en Gestión del Talento Humano (virtual) con (Doble titulación)",
				"Maestría en Innovación y Emprendimiento"
			],
			"43": [
				"Maestría en Comportamiento No Verbal y Detección del Engaño",
				"Maestría en Dirección y Gestión de Proyectos",
				"Maestría en Finanzas Avanzadas",
				"Maestría en Gestión del Talento Humano",
				"Maestría en Gestión y Evaluación de Sistemas Productivos Sostenibles",
				"Maestría en Modelado y Gestión de Proyectos de Construcción BIM MANAGEMENT",
				"Maestría en Perfilación Criminal",
				"Maestría en Perfilación de la Personalidad, Negociación y Mediación",
				"Maestría en Turismo Sostenible",
				"Master  Security Data Science and Cybersecurity",
				"Master Business Intelligence and Analytics",
				"Master Food Innovation & Global Management",
				"MBA+"
			],
			"44": ["Maestría en Comunicación y Gestión de Industrias Creativas"],
			"45": [
				"Maestría en Consejería Psicológica y Salud Mental",
				"Maestría en Desarrollo",
				"Maestría en Neuropsicología Clínica",
				"Maestría en Posgrados y Maestrías en Patrimonio",
				"Maestría en Psicología Aplicada",
				"Posgrado en Intervenciones con Artes Expresivas",
				"Posgrado en Monitoreo y Evaluación de Proyectos Sociales",
				"Posgrado en Políticas Públicas para el Desarrollo"
			],
			"46": ["Maestría en Derecho Procesal", "Maestría en Derecho Penal Jurisprudencial"],
			"47": ["Maestría en Ortodoncia y Ortopedia Dentofacial", "Maestría en Rehabilitación Oral y Odontología Cosmética"],
			"48": ["Maestría en Ciencias Bíblicas"],
			"49": ["Maestría en Enfoques Psicoterapéuticos", "Maestría en Desarrollo Humano Empresarial"],
			"50": ["Maestría en Economía con Especialización en Comercio Internacional", "Maestría en Contabilidad y Auditoría Internacional con Enfoque en Riesgos"],
			"51": ["Maestría en Ciencias Criminológicas y Criminalísticas"],
			"52": [
				"Doctorado en Administración con Especialidad en Alto Desempeño",
				"Doctorado en Administración con Especialidad en Finanzas",
				"Doctorado en Administración Pública y Políticas Públicas",
				"Doctorado en Ingeniería Industrial"
			],
			"53": ["Doctorado en Derecho y Justicia"],
			"54": ["Diplomado SCRUM", "Certificación Lean Six Sigma", "Diplomado de Banca, Inflación y Tasa de Cambio"],
			"55": ["Diplomado en Instrumentación y Control Automático de Procesos Industriales", "Diplomado en Adminitración de la Calidad"],
			"56": ["Diplomado de Formación del Cuidador del Paciente Renal Crónico", "Diplomado en Implantodoncia", "Diplomado en Gerontología"],
			"57": ["Diplomado en Educación Turística", "Diplomado en Trastornos de Aprendizaje"]
		}
	});
	window.strings = strings;
	let sLang = supportLang.find(l => l.code === document.documentElement.lang);
	// add direction to supportLang
	document.documentElement.dir = sLang?.direction || "ltr";
}

function replaceStringDictionary(str: object) {
	Object.assign(strings, str);
	// @ts-ignore
	// Object.keys(str).forEach((key: string) => (strings[key] = str[key]));
}

// @ts-ignore
export const strings: { [key in keyof typeof es]: (typeof es)[key] } = {};
